export default __webpack_public_path__ + "static/media/TopExpo_LOGO1_2.75bd2c3e.webp";